import ApiService from "@/common/api/api.service";

export const ServiceService = {

    list_categories(slug='') {
        ApiService.setHeader()
        return ApiService.get('services/categories', slug)
    },
    list() {
        ApiService.setHeader()
        return ApiService.get(`services/simple`)
    },
    listBM(id) {
        ApiService.setHeader()
        return ApiService.get(`/bm/${id}/services/simple`)
    },

    search(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`services?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },

    get(slug) {
        ApiService.setHeader()
        return ApiService.get('services', slug)
    },
    bmServices(slug) {
        ApiService.setHeader()
        return ApiService.get(`/bm/${slug}/services`, "")
    },
    bmScheduleServices(slug) {
        ApiService.setHeader()
        return ApiService.get(`/bm/${slug}/scheduleServices`, "")
    },


    create(data) {
        ApiService.setHeader()
        return ApiService.post('services', data)
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('services', slug, data)
    },
    active(id) {
        ApiService.setHeader()
        return ApiService.update(`services/${id}/active`)
    },
    inactive(id) {
        ApiService.setHeader()
        return ApiService.update(`services/${id}/inactive`)
    },

    delete(id) {
        ApiService.setHeader()
        return ApiService.delete(`services/${id}`)
    }
}